// Urdu (RTL) — top-level translations. Falls back to English for missing keys.
import en from "./en";

const ur = {
  ...en,
  ui: {
    ...en.ui,
    brand: "My World Quest",
    brand_subtitle: "رنگ بھرو اور سیکھو",
    nav: {
      home: "گھر", countries: "ممالک", globe: "گلوب", continents: "براعظم",
      color: "رنگ", puzzles: "پہیلیاں", games: "کھیل", math: "جیو ریاضی",
      trip: "سفر", advanced: "اعلیٰ", stickers: "اسٹیکر", quiz: "کوئز", parents: "والدین", more: "اور",
     "geo-lines": "دنیا کی لکیریں", "maths-academy": "میتھ اکیڈمی",},
    accessibility: { bigText: "بڑا متن", highContrast: "زیادہ کنٹراسٹ" },
    navGroups: { quick: "فوری", explore: "دریافت", play: "کھیلیں اور سیکھیں", collect: "جمع", adv: "مہم", grownup: "بڑوں کے لیے" },
    actions: { back: "واپس", close: "بند کریں", reset: "ری سیٹ", save: "محفوظ کریں", retry: "دوبارہ کوشش", playAgain: "دوبارہ کھیلیں" },
  },
  microcopy: {
    ...en.microcopy,
    great: "زبردست! ⭐",
    correct: "✅ درست!",
    nope: "دوبارہ کوشش کریں!",
    tryAgain: "تقریباً۔ جاری رکھیں!",
    awesome: "شاندار!",
    welcome: "{{country}} میں خوش آمدید! آؤ {{language}} سیکھیں۔",
    youDidIt: "آپ نے کر دکھایا!",
    perfect: "بہترین!",
  },
  home: {
    ...en.home,
    title1: "دنیا کو دریافت کریں",
    title2: "ایک وقت میں ایک ملک",
    subtitle: "تفریحی جغرافیائی مہم جوئیاں، کوئز، چیلنجز اور انعامات جو بچوں کو ممالک، ثقافتوں، جھنڈوں، مقامات اور مزید کو دریافت کرنے میں مدد دیتے ہیں۔",
    playNow: "ابھی کھیلیں →",
    takeQuiz: "کوئز کریں",
    openGlobe: "بڑا گلوب کھولیں →",
    globeHint: "ملک سیکھنے کے لیے چمکتا پن دبائیں!",
    popularCountries: "یا کوئی جھنڈا دبائیں",
    whatNext: "آج آپ کیا کرنا چاہیں گے؟",
    whatNextSub: "جو پسند ہو منتخب کریں — سب مزے دار ہے!",
    tiles: {
      ...en.home.tiles,
      learn: "ممالک سیکھیں", learnDesc: "30+ ممالک جھنڈوں کے ساتھ!",
      globe: "3D گلوب", globeDesc: "گھمائیں اور دریافت کریں",
      continents: "براعظم", continentsDesc: "ساتوں براعظم کی سیر",
      color: "نشانیاں رنگیں", colorDesc: "ایفل ٹاور رنگیں!",
      math: "جغرافیہ ریاضی", mathDesc: "کلومیٹر جوڑیں، ممالک گنیں!",
      quiz: "کوئز کا وقت", quizDesc: "بنیادی اور اعلیٰ کوئز",
      parents: "والدین کے لیے", parentsDesc: "بچے کی پیش رفت دیکھیں",
    },
  },
  learn: {
    title: "ممالک سیکھیں", capital: "دارالحکومت", language: "زبان", hello: "ہیلو",
    learnIt: "میں نے سیکھ لیا!", listen: "سنیں",
    goalsEyebrow: "آج کے تعلیمی مقاصد",
    goalsHeading: "🎯 پہلے ان پر توجہ دیں",
    goalsSubtitle: "{{tier}} سال کی عمر میں سیکھنے کی چار سب سے اہم چیزیں — نصاب سے منتخب۔",
    goalsAllTopics: "تمام موضوعات دیکھیں",
    goalsLearnNow: "ابھی سیکھیں",
    goalsKey: "اہم #{{n}}",
    topicTitles: {
      "art-design": "ڈرائنگ، پینٹنگ اور ڈیزائن",
      "music": "موسیقی: تال، گانا اور نوٹیشن",
      "computing-code": "کوڈنگ، الگورتھم اور آن لائن سیفٹی",
      "physical-education": "جسمانی تعلیم، صحت اور فٹنس",
      "world-religions": "دنیا کے مذاہب اور عقائد",
      "wellbeing-relationships": "صحت، جذبات اور دوستی",
    },
  },
  globe: {
    title: "3D گلوب", subtitle: "گھمائیں اور دریافت کریں",
    learnLang: "زبان سیکھیں", moreInfo: "مزید معلومات", learnedTag: "✓ سیکھ لیا",
    spinTap: "گلوب گھمائیں اور ملک پر کلک کریں!", spinTapSub: "پن دبا کر مزید جانیں۔",
  },
  quiz: {
    title: "کوئز کا وقت", basic: "بنیادی", advanced: "اعلیٰ",
    start: "کوئز شروع", next: "اگلا →", finish: "ختم!", score: "اسکور",
  },
  stickers: { title: "میرا اسٹیکر البم", subtitle: "ہر سرگرمی سے ایک اسٹیکر جمع کریں!" },
  langSwitcher: {
    label: "زبان",
    english: "English", french: "Français", hindi: "हिन्दी", arabic: "العربية", urdu: "اردو",
    italian: "Italiano", spanish: "Español", mandarin: "中文", japanese: "日本語", korean: "한국어", swahili: "Kiswahili",
  },
  common: {
    whereToNext: "اب کہاں جائیں؟",
    home: "ہوم",
    earnMoreStars: "⭐ مزید ستارے کمائیں",
    earnHowTo: "ایک تیز کھیل کھیلیں — ہر ایک XP دیتا ہے!",
    pickAge: "عمر منتخب کریں",
    ages: "عمر",
    startExploring: "تلاش شروع کریں",
    pickAnywhere: "اوپر سے منتخب کریں — یا یہاں دبائیں!",
    tapAnyCountry: "کسی ملک پر دبائیں اور اس کی کہانی سنیں!",
    exploreGlobe: "گلوب کو دیکھیں",
    exploreGlobeSub: "فل اسکرین 3D ایڈونچر",
  },
  shortcuts: {
    home: "ہوم",
    continents: "براعظم",
    globe: "گلوب",
    ask: "پوچھیں",
    landmarks: "مقامات",
    flags: "جھنڈے",
    pixel: "پکسل",
    puzzles: "پہیلیاں",
    math: "ریاضی",
    trip: "سفر",
    quiz: "کوئز",
    quests: "تلاش",
    stickers: "اسٹیکر",
    miniGames: "چھوٹے کھیل",
    geoMath: "جغرافیہ ریاضی",
    quickQuiz: "تیز کوئز",
    myTrophies: "میری ٹرافیاں",
    colorCreate: "رنگ اور تخلیق",
    spinGlobe: "گلوب گھمائیں",
    askGlobe: "گلوب سے پوچھیں",
    dreamTrip: "خوابوں کا سفر",
    earnStars: "ستارے کمائیں",
    tryAQuest: "ایک تلاش کریں",
    playAgain: "دوبارہ کھیلیں",
    learnCountry: "ملک سیکھیں",
    colorLandmark: "مقام رنگیں",
    learnCountries: "ممالک سیکھیں",
    advanced: "ایڈوانس موڈ",
    spellCountry: "ملک کا نام لکھیں",
    advancedHub: "اعلیٰ سطح",
    squishyHop: "اسکویشی ہاپ",
    mathSnap: "میتھ اسنیپ",
    language: "زبان",
    geoLines: "دنیا کی لکیریں",
  },
  coloringExtra: {
    modeLandmarks: "مقامات",
    modeFlags: "جھنڈا فنکار",
    modePixel: "پکسل آرٹ",
    diffEasy: "آسان",
    diffMedium: "درمیانہ",
    diffExpert: "ماہر",
    difficultyLabel: "مشکل:",
  },
  tilesExtra: {
    labelLearn: "سیکھیں",
    labelCreate: "بنائیں",
    labelPlay: "کھیلیں",
    labelTrophies: "ٹرافیاں",
    whatNextSub: "کوئی بھی منتخب کریں — سب مزے دار ہے!",
  },
  pills: {
    orTry: "یا کوشش کریں ↓",
    
    squishyHop: "اسکویشی ہاپ",
    mathSnap: "میتھ سنیپ",colorLandmark: "ایک مقام رنگیں",
    solvePuzzle: "ایک پہیلی حل کریں",
    dreamTrip: "خوابوں کا سفر",
    geoMath: "جغرافیہ ریاضی آزمائیں",
    continentQuests: "براعظم مہمات",
    stickerBook: "اسٹیکر کتاب",
    famousPeople: "مشہور لوگ ملیں",
    culturalSpot: "ثقافتی مقام",
    quickQuiz: "تیز کوئز",
    continentMaps: "براعظمی نقشے",
    spellCountry: "ملک کا نام لکھیں",
    flagArtist: "جھنڈا فنکار",
    pixelArt: "پکسل آرٹ",
    spinGlobe: "گلوب گھمائیں",
    askGlobe: "گلوب سے پوچھیں",
    myTrophies: "میری ٹرافیاں",
    advancedHub: "اعلیٰ سطح",
    geoLines: "دنیا کی لکیریں",
  },
  canvas: {
    tools: "اوزار",
    brushSize: "برش سائز",
    colors: "رنگ",
    patterns: "پیٹرن",
    modes: "موڈز",
    solid: "ٹھوس",
    anyColor: "کوئی بھی رنگ",
    recent: "حالیہ",
    sticker: "اسٹیکر",
    symmetry: "تناسب",
    colorByNumber: "نمبر سے رنگ",
    reference: "حوالہ",
    undo: "واپس",
    redo: "دوبارہ",
    reset: "ری سیٹ",
    replay: "ری پلے",
    check: "چیک",
    save: "محفوظ",
    fill: "بھریں",
    pencil: "پنسل",
    stamp: "اسٹیمپ",
    erase: "مٹائیں",
    on: "آن",
    off: "آف",
    tool: "اوزار:",
    pattern: "پیٹرن:",
    printOne: "پرنٹ",
    downloadAll: "سب ڈاؤن لوڈ",
    appTitle: "رنگ اور تخلیق 🎨",
    appSub: "برش، پیٹرن، اسٹیکر، نمبر سے رنگ اور بہت کچھ!",
  },
};

export default ur;
